import { Text } from '@_/ui';
import { CommentBodyWrapper } from './CommentBodyWrapper.tsx';

export function CommentBody({ text }: { text: string | null }) {
  return <CommentBodyWrapper>{!!text && <Text>{text}</Text>}</CommentBodyWrapper>;
}
